/*
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
'use strict';

/* ----- Client Namespace ------------------------------------------------------------------------------------------- */
var RCA = window.RCA = window.RCA || {};
RCA.client = RCA.client || {};

/* ----- Global Variables ------------------------------------------------------------------------------------------- */
/* localState declared in /src/shared/common.js */
RCA.shared.localState.layout = RCA.shared.localState.layout || [];
//localState.lang = localState.lang || 'hu';
/* ----- Hold Ready ------------------------------------------------------------------------------------------------- */
//$.holdReady(true);

RCA.client._ajaxReadyModClient = function (data) {
    $('.bodycontent').html(data);
    $('div.main').hide();
    RCA.shared.is_ready.html = true;
    //$.holdReady(false);
}

/* Start client initialization after the concatenated client bundle has loaded. */
setTimeout(function () {
    RCA.client.checkReady();
    /* Load Client Fragment Content */
    $.get(RCA.shared.url_rewrite + 'modules/mod_client.html', RCA.client._ajaxReadyModClient);
}, 0);

RCA.client.checkReady = function () {
    if (RCA.shared.is_ready.config && RCA.shared.is_ready.html) {
        clearTimeout(RCA.shared.waitForReady);
        //$.holdReady(false);
        RCA.shared.sharedReady();
        RCA.client.clientReady();

        $.ajaxSetup({ cache: false });
    } else {
        RCA.shared.waitForReady = setTimeout(function (){
            RCA.client.checkReady();
        }, 100);
    }
}

RCA.client.clientEventListeners = [];
RCA.client.hide_emojis = undefined;
RCA.client.allow_hide = true;

/* ----- Process on Document Ready ---------------------------------------------------------------------------------- */
RCA.client.clientReady = function () {
    /* Init Core */
    RCA.client.Layout.Init();
    RCA.shared.Language.Init(localStorage.getItem("rca4_lang") || RCA.shared.AppData.profile.user_lang);
    if (!RCA.client.Settings.Init()) {
        return;
    }

    RCA.client.Navigation.Init();
    /* Init Modules */
    RCA.client.Modal.Init();
    RCA.client.Game.Init();
    RCA.client.Agenda.Init();
    RCA.client.Speakers.Init();
    RCA.client.Useful.Init();
    RCA.client.Docs.Init();
    //Surveys.Init();
    RCA.client.Quiz.Init();
    RCA.client.Attendees.Init();
    RCA.client.Profile.Init();
    RCA.client.Qrcode.Init();
    RCA.client.Roomlist.Init();
    RCA.client.ChangePass.Init();
    RCA.client.Notes.Init();
    RCA.client.Points.Init();
    RCA.client.Moderate.Init();
    RCA.client.Stage.Init();
    RCA.client.Issues.Init();
    RCA.client.Bookings.Init();
    RCA.client.Weblinks.Init();
    RCA.client.Messageboard.Init();
    RCA.client.Namecards.Init();
    RCA.client.Photos.Init();
    RCA.client.Broadcast.Init();
    RCA.client.Chat.Init();
    RCA.client.FavoriteAgenda.Init();
    RCA.client.Gdpr.Init();
    RCA.client.Translator.Init();
    RCA.client.Soundchannels.Init();
    RCA.client.Gallery.Init();
    RCA.client.Camerastream.Init();
    RCA.client.Notifications.Init();
    RCA.client.Trueconf.Init();
    RCA.client.Unity3d.Init();
    RCA.client.Ondemandvideos.Init();
    RCA.client.TranslatorRelay.Init();
    RCA.client.Texts.Init();
    RCA.client.Tetris.Init();
    RCA.client.Sponsors.Init();
    RCA.client.Channels.Init();
    RCA.client.Modulsettings.Update();

    RCA.shared.Kiosk.setKiosk(RCA.shared.AppData.settings.camera_postmessage == "1");

    RCA.client.setHomeScreenVideo();

    if (RCA.shared.AppData.profile.presi_control == 1) {
        //$(".presentation").remove();
        RCA.client.SpeakerPresentation.Init();
    } else {
        $(".speaker_presentation").remove();
    }

    RCA.client.Presentation.Init();

    RCA.client.startEnigma();
    RCA.client.startCatchit();

    /* Deferred Functions */
    $(document).on('animationend', RCA.client.lazyImages);

    var observerEnigma = new MutationObserver(function(mutationsList, observer) {
        for(var m in mutationsList) {
            if ($(mutationsList[m].target).attr("id") == "enigma") {
                if(!$(mutationsList[m].target).is(":visible")) {
                    RCA.client.enigmaGame.reset_game();
                }
            }
        }
    });

    observerEnigma.observe($("#enigma").get(0), { attributes: true, childList: true, subtree: true });

    var observerCatchit = new MutationObserver(function(mutationsList, observer) {
        for(var m in mutationsList) {
            if ($(mutationsList[m].target).attr("id") == "catchit") {
                if(!$(mutationsList[m].target).is(":visible")) {
                    RCA.client.catchit_game.hideGame();
                }
            }
        }
    });

    observerCatchit.observe($("#catchit").get(0), { attributes: true, childList: true, subtree: true });

    var observerWeblinks = new MutationObserver(function(mutationsList, observer) {
        for(var m in mutationsList) {
            if ($(mutationsList[m].target).attr("id") == "weblinks-details") {
                if(!$(mutationsList[m].target).is(":visible")) {
                    clearTimeout(RCA.client.Weblinks.loadtimer);
                    $("#weblinksIframeId").unbind("load");
                    $("#weblinksIframeId").attr("src", "");
                }
            }
        }
    });

    observerWeblinks.observe($(".bodycontent > #weblinks-details").get(0), { attributes: true, childList: true, subtree: true });

    var observerTetris = new MutationObserver(function(mutationsList, observer) {
        for(var m in mutationsList) {
            if ($(mutationsList[m].target).attr("id") == "tetris") {
                if(!$(mutationsList[m].target).is(":visible")) {
                    RCA.client.Tetris.pauseGame();
                }
            }
        }
    });

    observerTetris.observe($("#tetris").get(0), { attributes: true, childList: true, subtree: true });

    //let v_ti = $(".videostream, .trueconf");
    let v_ti = $("#landing");
    let sr = $(".stream_reactions");

    v_ti.on("mouseover touchend", function(){
        if (RCA.shared.AppData.modulsettings.show_emoji_reactions && $(".videostream, .trueconf").is(":visible")) {
            $(".stream_reactions").removeClass("hidden");
            clearTimeout(RCA.client.hide_emojis);
            RCA.client.hide_emojis = setTimeout(RCA.client.hideEmojis, 2000);
        }
    });

    v_ti.on("mousemove", function(){
        clearTimeout(RCA.client.hide_emojis);
        if (RCA.shared.AppData.modulsettings.show_emoji_reactions && $(".videostream, .trueconf").is(":visible")) {
            $(".stream_reactions").removeClass("hidden");
            RCA.client.hide_emojis = setTimeout(RCA.client.hideEmojis, 2000);
        }
    });

    v_ti.on("mouseleave", function(){
        if (RCA.shared.AppData.modulsettings.show_emoji_reactions && $(".videostream, .trueconf").is(":visible")) {
            clearTimeout(RCA.client.hide_emojis);
            RCA.client.hide_emojis = setTimeout(RCA.client.hideEmojis, 2000);
        }
    });

    sr.on("mouseover", function(){
        RCA.client.allow_hide = false;
    });

    sr.on("mouseleave", function(){
        RCA.client.allow_hide = true;
    });
}

RCA.client.refreshDays = function () {
    $.post('api/', {
        do: 'getDays'
    }, function (data) {
        RCA.shared.AppData.days = data;
        RCA.client.Agenda.BuildFromSource();
        RCA.client.Issues.BuildFromSource();
        RCA.client.Layout.hide("issues-details");
    });
}

RCA.client.fakeReactions = function (type) {
    if (RCA.shared.AppData.modulsettings.allowreactions && RCA.client.randInt(0, 100) > 30) {
        setTimeout(function () {
            //if (randInt(0, 100) > 50) {
            if (type != undefined) {
                if (type == "laugh") {
                    $("#landing .reactions .laugh").trigger("click");
                } else if (type == "clap") {
                    $("#landing .reactions .clap").trigger("click");
                }
            } else {
                if (RCA.client.randInt(0, 100) > 50) {
                    $("#landing .reactions .laugh").trigger("click");
                } else {
                    $("#landing .reactions .clap").trigger("click");
                }
            }
        }, RCA.client.randInt(100, 400));
    }
}

RCA.client.trueconf_opened = false;
RCA.client.trueconf_translator_opened = false;

RCA.client.openTrueConfCall = function (room, server, channel, new_window, translator) {
    $.ajax({
        method: 'post',
        url: 'api/',
        data: {
            do: 'openTrueConfCall',
            room: room,
            server: server,
            guestname: RCA.shared.AppData.profile.name[RCA.shared.localState.lang]
        },
        success: function (response) {
            if (response.trueconf_url != "") {
                RCA.shared.writeDbLog("open trueconf room", response.trueconf_url, "user_logs", "trueconf");
                if (new_window === true) {
                    window.open(response.trueconf_url, "chat_" + room);
                } else {
                    if (translator == true) {
                        $("#landing .landing_elements .trueconf_translator").show();
                        $("#trueconf_iframe_translator").attr("src", response.trueconf_url);
                        RCA.client.trueconf_translator_opened = true;
                    } else {
                        $("#landing .landing_elements .trueconf").show();
                        $("#trueconf_iframe").attr("src", response.trueconf_url);

                        if (RCA.shared.AppData.modulsettings.show_emoji_reactions) {
                            //$(".stream_reactions").appendTo($(".landing_elements .trueconf"));
                            $(".stream_reactions").removeClass("hidden");
                        } else {
                            $(".stream_reactions").addClass("hidden");
                        }

                        RCA.client.trueconf_opened = true;
                    }

                    RCA.client.Layout.hideAll();
                    RCA.client.Broadcast.stopVideoStream();
                    RCA.client.Navigation.hideMenu();
                }
                if (channel != "" && channel != undefined) {
                    RCA.client.Channels.setChannel(channel)
                }
            } else {
                RCA.client.Modal.alert(RCA.shared.Language.getItem("conference-not-available"));
                $("#default_nav").find("[data-target='trueconf']").css("border", '');
            }
        }
    });
}

$(document).on("click", ".trueconf-button.hangup", function (){
    let type = $(this).attr("data-type");
    RCA.client.closeTrueConfCall(type);
});

window.addEventListener('message', (e) => {
    if (e.origin === 'https://meeting2.rentit.hu' || e.origin === 'https://meeting3.rentit.hu' || e.origin === 'https://meeting5.rentit.hu' || e.origin === 'https://meeting6.rentit.hu') {
        console.log(e);
        if (e.data.type === 'connectionClosed') {
            RCA.client.closeTrueConfCall("default");
        }
    }

    if (e.data.type === "open3D") {
        RCA.client.Unity3d.load3DPlayer(e.data.scene || "default", e.data.url);
    }

    if (e.data.type === "callRoom") {
        RCA.client.closeTrueConfCall();
        RCA.client.openTrueConfCall(e.data.room, 'workshop');
    }

    if (RCA.shared.AppData.settings.infopanel_url.indexOf(e.origin) > -1) {
        if (e.data.type === "openTrueConf") {
            RCA.client.Unity3d.call_exhibitor(e.data.room);
        }

        if (e.data.type === "openChat") {
            RCA.client.Unity3d.openTextChat(e.data.uid);
        }

        if (e.data.type === "fisu_dwf_360") {
            //hungary_promo_videos
            //welcome
            //universiade_2021
            RCA.client.Ondemandvideos.showList(e.data.target);
        }

        if (e.data.type === "open_eep") {
            var url = RCA.shared.AppData.settings.infopanel_url + '/' + e.data.target;
            url += "?pid="+encodeURIComponent(btoa(RCA.shared.AppData.profile.id));

            RCA.client.Weblinks.showPortal(url);
        }
    }
});

RCA.client.from3d = false;

RCA.client.closeTrueConfCall = function (type) {
    if (RCA.client.trueconf_opened && type == "default") {
        $("#trueconf_iframe").attr("src", "");
        $("#landing .landing_elements .trueconf").hide();
        $("#default_nav").find("[data-target='trueconf']").css("border", '');
        RCA.client.trueconf_opened = false;
    }

    if (RCA.client.trueconf_translator_opened && type == "translator") {
        $("#trueconf_iframe_translator").attr("src", "");
        $("#landing .landing_elements .trueconf_translator").hide();
        $("#default_nav").find("[data-target='trueconf']").css("border", '');
        RCA.client.trueconf_translator_opened = false;
    }

    if (RCA.client.from3d !== false && type != "3d") {
        RCA.client.trueconf_opened = false;
        RCA.client.Unity3d.load3DPlayer("default", RCA.client.from3d);
    }

    $(".stream_reactions").addClass("hidden");
}

RCA.client.logVideoWatch = function (action, stream_url) {
    $.ajax({
        method: 'post',
        url: 'api/',
        data: {
            do: 'logVideoWatch',
            action: action,
            stream_url: stream_url
        }
    });
}

$(document).on('click', '.stream_reactions .reaction_emoji', function (e) {
    let icon = $(this).attr("data-type");

    RCA.shared.writeDbLog(icon, RCA.shared.localState.currentChannel, 'user_logs');

    RCA.shared.Socket.Send("sendStreamReaction", {icon: icon, own: false}, {
        channel: RCA.shared.localState.currentChannel
    });

    RCA.client.sendStreamReaction({icon: icon, own: true});
});

RCA.client.hideEmojis = function () {
    if (RCA.client.allow_hide && !$(".trueconf").is(":visible")) {
        $(".stream_reactions").fadeOut(800, function () {
            $(this).removeAttr("style").addClass("hidden");
        });
    }
}

RCA.client.sendStreamReaction = function (data) {
    let element;
    if ($(".videostream").is(":visible")) {
        element = $(".videostream");
    }

    if ($("#trueconf_iframe").is(":visible")) {
        element = $("#trueconf_iframe");
    }

    if (element != undefined) {
        let reaction = $("<span/>");
        let emoji = $(".stream_reactions [data-type='"+data.icon+"']").html();

        reaction.html(emoji);
        reaction.appendTo($(".landing_elements"));
        reaction.addClass("animated_reaction");

        let left, top;
        if (data.own) {
            if (RCA.shared.AppData.modulsettings.emoji_pos == "left") {
                reaction.addClass("left");
                top = $(".stream_reactions [data-type='" + data.icon + "']").offset().top + ($(".stream_reactions [data-type='" + data.icon + "']").height() / 2) - (reaction.height() / 2) - $(".landing_elements").offset().top;
                reaction.css({
                    top: top
                });
            } else if (RCA.shared.AppData.modulsettings.emoji_pos == "top") {
                reaction.addClass("top");
                left = $(".stream_reactions [data-type='" + data.icon + "']").offset().left + ($(".stream_reactions [data-type='" + data.icon + "']").width() / 2) - (reaction.width() / 2);
                reaction.css({
                    left: left
                });
            } else {
                left = $(".stream_reactions [data-type='" + data.icon + "']").offset().left + ($(".stream_reactions [data-type='" + data.icon + "']").width() / 2) - (reaction.width() / 2);
                reaction.css({
                    left: left
                });
            }
        } else {
            let half_window = $(window).width() / 2;
            left = half_window + RCA.client.randInt(-half_window / 2, half_window / 2);

            reaction.css({
                left: left
            });
        }



        setTimeout(function (){
            reaction.remove();
        }, 1200);
    }
}

RCA.client.refreshModule = function (data) {
    //let capitalizedModule = data.module.charAt(0).toUpperCase() + data.module.slice(1);

    if (RCA.shared.AppData[data.appdata] != undefined) {
        RCA.shared.AppData[data.appdata] = data.use_lang ? data.data[RCA.shared.localState.lang] : data.data;
    }

    for(let i in data.module) {
        var module = RCA.client[data.module[i]];
        if (module != undefined) {
            if (typeof module[data.callback[i]] === "function") {
                module[data.callback[i]].apply(module, data.callback_params ? [data.callback_params[i]] : null);
            }
        }
    }
}

RCA.client.updateModifiedContent = function (data) {
    let has_updated = false;
    let capitalizedModule = data.module.charAt(0).toUpperCase() + data.module.slice(1);
    let module = RCA.client[capitalizedModule];

    if (data.only_callback === true) {
        if (module && typeof module[data.callback] === "function") {
            module[data.callback].apply(module, [data.callback_params] || null);
        }
        return;
    }

    if (RCA.shared.AppData[data.module] != undefined) {
        $.each(RCA.shared.AppData[data.module], function (i, el) {
            if (el[data.id_field] == data.id_value) {
                RCA.shared.AppData[data.module][i] = data.updated_content;
                has_updated = true;
            }
        });

        if (has_updated && data.callback != undefined) {
            if (module && typeof module[data.callback] === "function") {
                module[data.callback].apply(module, [data.callback_params] || null);
            }
        }
    }
}

/* ----- Lazy Load Images ------------------------------------------------------------------------------------------- */
RCA.client.lazyImages = function () {
    var $images = $('img[data-src]:visible:lt(1)');
    if ($images.length) {
        $images
            .attr({
                src: function () {
                    return $(this).attr('data-src');
                },
                'data-src': null
            });
        $images = null;
        requestAnimationFrame(RCA.client.lazyImages);
    }
}

/* ----- nl2br ------------------------------------------------------------------------------------------------------ */
RCA.client.nl2br = function (input) {
    return String(input)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/(\r\n|\n\r|\r|\n)/g, '<br>' + '$1');
}

RCA.client.nl2brStrict = function (input) {
    return String(input)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/(\r\n|\n\r|\r|\n)/g, '<br>' + '$1');
}

RCA.client.nl2brOnly = function (input) {
    return String(input)
        .replace(/(\r\n|\n\r|\r|\n)/g, '<br>' + '$1');
}

RCA.client.makeTimeFormat = function (time, timeformat) {
    var newTime,
        ampm;

    if(time != "") {
        if (timeformat === "12") {
            if (parseInt(time) >= 13) {
                newTime = "0" + (parseInt(time) - 12) + time.substr(time.indexOf(":"));
            } else {
                newTime = time;
            }

            if (parseInt(time) >= 12) {
                ampm = "PM";
            } else {
                ampm = "AM";
            }
            return newTime + ampm;
        }
    }
    return time;
}

/* ----- Log Out ---------------------------------------------------------------------------------------------------- */
RCA.client.logOut = function () {
    RCA.client.Modal.confirm(RCA.shared.Language.getItem('logout-text'), function () {
        RCA.shared.writeDbLog("logout", "","user_logs", "logout");
        $.post('api/', {
            do: 'logOut'
        });

        if (typeof window.webkit !== "undefined") {
            window.webkit.messageHandlers.logOut.postMessage('logout');
        }

        if (typeof Android !== "undefined") {
            Android.logout();
        }
    });
}

$(document).on('click', '.logout', RCA.client.logOut);

RCA.client.forceLogOut = function () {
    RCA.shared.writeDbLog("force logout", "", "user_logs", "logout");
    $.post('api/', {
        do: 'logOut'
    });

    if (typeof window.webkit !== "undefined") {
        window.webkit.messageHandlers.logOut.postMessage('logout');
    }

    if (typeof Android !== "undefined") {
        Android.logout();
    }
}

RCA.client.setHomeScreenVideo = function () {

    var streamplayer = videojs('my-video-bg');
    if (RCA.shared.AppData.settings.showHomeScreenVideo) {
        if ('homescreenVideo' in RCA.shared.AppData.settings) {
            let fg = RCA.shared.AppData.medias.find(function (item){
                return item.id === RCA.shared.AppData.settings.homescreenVideo;
            });
            if (fg && fg.files[RCA.shared.localState.lang].file != undefined) {
                if (!streamplayer.paused) {
                    streamplayer.pause();
                }
                streamplayer.src(fg.files[RCA.shared.localState.lang].file);
                streamplayer.load();
                streamplayer.play();
                $("#playerElementBackground").show();
            }
        }
    } else {
        streamplayer.paused(true);
        $("#playerElementBackground").hide();
    }


}
